const ScreensEnum =
{
    "chatPopup": -1,
    "chatButton": 1,
    "startConversation": 2,
    "conversationClient": 3,
    "endConversation": 4,
    "transcript": 5,
    "transcriptSuccess": 6
};

const MessageDirection =
{
    "Incoming": 0,
    "Outgoing": 1
};

export {ScreensEnum, MessageDirection};